/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления измерениями
 */

/**
 * Сервис измерений
 */
export class MeasurementServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения измерений.
   * Метод доступен для: service, application(telemetry:edit)
   */
  PostMeasurement = (req: PostMeasurementRequestDto, init?: RequestInit): Promise<PostMeasurementResponseDto> => {
    return fm.request<PostMeasurementRequestDto, PostMeasurementResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  // method PostMeasurementHalfDuplex(client streams) not supported yet

  /**
   * Метод получения списка измерений.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetMeasurementList = (req?: GetMeasurementListRequestDto, init?: RequestInit): Promise<GetMeasurementListResponseDto[]> => {
    return fm.list<GetMeasurementListRequestDto, GetMeasurementListResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества измерений.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetMeasurementCount = (req?: GetMeasurementCountRequestDto, init?: RequestInit): Promise<GetMeasurementCountResponseDto> => {
    return fm.request<GetMeasurementCountRequestDto, GetMeasurementCountResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка преобразованных измерений.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetMeasurementConvertedList = (req?: GetMeasurementConvertedListRequestDto, init?: RequestInit): Promise<GetMeasurementConvertedListResponseDto[]> => {
    return fm.list<GetMeasurementConvertedListRequestDto, GetMeasurementConvertedListResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement/converted/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества преобразованных измерений.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetMeasurementConvertedCount = (req?: GetMeasurementConvertedCountRequestDto, init?: RequestInit): Promise<GetMeasurementConvertedCountResponseDto> => {
    return fm.request<GetMeasurementConvertedCountRequestDto, GetMeasurementConvertedCountResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement/converted/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения отчета на дату по идивидуальным приборам учёта.
   * Метод доступен для: service, application(telemetry:read)
   */
  GetMeasurementReportDate = (req: GetMeasurementReportDateRequestDto, init?: RequestInit): Promise<GetMeasurementReportDateResponseDto> => {
    return fm.request<GetMeasurementReportDateRequestDto, GetMeasurementReportDateResponseDto>(`${this.host}/telemetry_metric/api/v1/measurement/report/date${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов устройств
 */
export enum MeasurementDeviceType {
  /**
   * Значение не указано
   */
  DEVICE_TYPE_UNKNOWN = "DEVICE_TYPE_UNKNOWN",
  /**
   * Коммуникационный модуль
   */
  HUB = "HUB",
  /**
   * Счетчик импульсов - регистратор
   */
  PULSE_COUNTER_RECORDER = "PULSE_COUNTER_RECORDER",
  /**
   * Счетчик импульсов - регистратор LoRaWAN
   */
  PULSE_COUNTER_RECORDER_LR = "PULSE_COUNTER_RECORDER_LR",
  /**
   * Прибор учета расхода коммунальных услуг
   */
  METERING_DEVICE = "METERING_DEVICE",
  /**
   * Конвертер интерфейсов
   */
  INTERFACE_CONVERTER = "INTERFACE_CONVERTER",
  /**
   * M-BUS концентратор
   */
  M_BUS_HUB = "M_BUS_HUB",
  /**
   * Модуль связи LoRaWAN
   */
  COMMUNICATION_MODULE_LR = "COMMUNICATION_MODULE_LR",
  /**
   * Базовая станция LoRaWAN
   */
  BASE_LR = "BASE_LR",
}
/**
 * Справочник типов устройств
 */
export type MeasurementDeviceTypeResponseEnum = keyof typeof MeasurementDeviceType
/**
 * Справочник типов устройств
 */
export type MeasurementDeviceTypeRequestEnum = Exclude<MeasurementDeviceTypeResponseEnum, "DEVICE_TYPE_UNKNOWN">;

/**
 * Справочник типов энергоресурсов
 */
export enum MeasurementMetricType {
  /**
   * Значение не указано
   */
  METRIC_TYPE_UNKNOWN = "METRIC_TYPE_UNKNOWN",
  /**
   * Горячая вода
   */
  HOT_WATER = "HOT_WATER",
  /**
   * Холодная вода
   */
  COLD_WATER = "COLD_WATER",
  /**
   * Теплоэнергия
   */
  HEAT = "HEAT",
  /**
   * Газ
   */
  GAS = "GAS",
  /**
   * Электроэнергия
   */
  ELECTRICITY = "ELECTRICITY",
}
/**
 * Справочник типов энергоресурсов
 */
export type MeasurementMetricTypeResponseEnum = keyof typeof MeasurementMetricType
/**
 * Справочник типов энергоресурсов
 */
export type MeasurementMetricTypeRequestEnum = Exclude<MeasurementMetricTypeResponseEnum, "METRIC_TYPE_UNKNOWN">;

/**
 * Справочник типов единиц измерений
 */
export enum MeasurementUnitType {
  /**
   * Значение не указано
   */
  UNIT_TYPE_UNKNOWN = "UNIT_TYPE_UNKNOWN",
  /**
   * Процент
   */
  PERCENT = "PERCENT",
  /**
   * Градус по Цельсию
   */
  C = "C",
  /**
   * Ватт
   */
  WT = "WT",
  /**
   * Гигакалория
   */
  GKAL = "GKAL",
  /**
   * Количество
   */
  VALUE = "VALUE",
  /**
   * Киловaтт-час
   */
  KWH = "KWH",
  /**
   * Килограмм на квадратный сантиметр
   */
  KG_CM2 = "KG_CM2",
  /**
   * Килограмм-сила на квадратный сантиметр
   */
  KGF_CM2 = "KGF_CM2",
  /**
   * Кубический метр
   */
  M3 = "M3",
  /**
   * Кубический метр в час
   */
  M3_H = "M3_H",
  /**
   * Мегапаскаль
   */
  MPA = "MPA",
  /**
   * Миллисекунда
   */
  MS = "MS",
  /**
   * Флаг состояния
   */
  BOOLEAN = "BOOLEAN",
  /**
   * Тонна
   */
  T = "T",
  /**
   * Тонна в час
   */
  T_H = "T_H",
  /**
   * Час
   */
  H = "H",
  /**
   * Безразмерная величина
   */
  NON_MEASURABLE = "NON_MEASURABLE",
  /**
   * Импульс
   */
  IMP = "IMP",
  /**
   * Джоуль
   */
  J = "J",
  /**
   * Килоджоуль
   */
  KJ = "KJ",
  /**
   * Гигаджоуль
   */
  GJ = "GJ",
  /**
   * Ватт-час
   */
  WTH = "WTH",
  /**
   * Киловатт
   */
  KWT = "KWT",
  /**
   * Минута
   */
  MIN = "MIN",
  /**
   * Секунда
   */
  S = "S",
}
/**
 * Справочник типов единиц измерений
 */
export type MeasurementUnitTypeResponseEnum = keyof typeof MeasurementUnitType
/**
 * Справочник типов единиц измерений
 */
export type MeasurementUnitTypeRequestEnum = Exclude<MeasurementUnitTypeResponseEnum, "UNIT_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum MeasurementPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type MeasurementPagingDirectionTypeResponseEnum = keyof typeof MeasurementPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type MeasurementPagingDirectionTypeRequestEnum = Exclude<MeasurementPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum MeasurementPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору индикатора
   */
  INDICATOR_ID = "INDICATOR_ID",
  /**
   * По дате synced_at
   */
  SYNCED_AT = "SYNCED_AT",
}
/**
 * Справочник типов значений сортировки
 */
export type MeasurementPagingOrderByTypeResponseEnum = keyof typeof MeasurementPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type MeasurementPagingOrderByTypeRequestEnum = Exclude<MeasurementPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества преобразованных измерений
 */
export type GetMeasurementConvertedCountRequestDto = {
  /**
   * Параметры фильтрации измерений
   */
  filter?: MeasurementFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества преобразованных измерений
 */
export type GetMeasurementConvertedCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего измерений
   */
  readonly data: number
}>
/**
 * Запрос получения списка преобразованных измерений
 */
export type GetMeasurementConvertedListRequestDto = {
  /**
   * Параметры фильтрации измерений
   */
  filter?: MeasurementFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Параметры пагинации по измерениям
   */
  readonly paging: MeasurementPagingRequestDto
}>
/**
 * Ответ на запрос получения списка преобразованных измерений
 */
export type GetMeasurementConvertedListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Значение измерения
   */
  readonly data: MeasurementResponseDto
}>
/**
 * Запрос получения количества измерений
 */
export type GetMeasurementCountRequestDto = {
  /**
   * Параметры фильтрации измерений
   */
  filter?: MeasurementFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества измерений
 */
export type GetMeasurementCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего измерений
   */
  readonly data: number
}>
/**
 * Запрос получения списка измерений
 */
export type GetMeasurementListRequestDto = {
  /**
   * Параметры фильтрации измерений
   */
  filter?: MeasurementFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Параметры пагинации по измерениям
   */
  readonly paging: MeasurementPagingRequestDto
}>
/**
 * Ответ на запрос получения списка измерений
 */
export type GetMeasurementListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Значение измерения
   */
  readonly data: MeasurementResponseDto
}>
/**
 * Запрос отчёта по показаниям на дату.
 * Если дата не передана, отчёт на текущую дату
 */
export type GetMeasurementReportDateRequestDto = {
  /**
   * Заданная дата отчёта
   */
  reportDateAt?: string | null
  /**
   * Список идентификаторов индикаторов.
   * Если не указано, в отчёт добавляются все индикаторы согласно фильтрам
   */
  indicatorIds?: number[]
  /**
   * Тип энергоресурса.
   * Обязательный, отчёт по одному ресурсу
   */
  metricType: MeasurementMetricTypeRequestEnum
}
/**
 * Ответ с отчётом по показаниям на дату
 */
export type GetMeasurementReportDateResponseDto = {
  /**
   * Уникальный идентификатор запроса. Формат GUID
   */
  requestId: string
  /**
   * Дата отчёта UTC
   */
  reportDateAt: string
  /**
   * Данные отчёта
   */
  data: ReportDataResponseDto | null
}
/**
 * Измерение.
 * Очередь key.telemetry_consumer.measurement_stream_request.v1
 */
export type MeasurementRequestDto = {
  /**
   * Идентификатор
   */
  indicatorId: number
  /**
   * Значение
   */
  value: number
  /**
   * Временная метка сбора счётчиком.
   * Если не передано берётся серверное время
   */
  syncedAt?: string | null
  /**
   * ФИАС
   */
  fiasId?: string | null
  /**
   * Идентификатор устройства
   */
  deviceId?: number | null
  /**
   * Идентификатор родительского устройства
   */
  deviceParentId?: number | null
  /**
   * Модель устройства
   */
  deviceModel?: string | null
  /**
   * Тип устройства
   */
  deviceType?: MeasurementDeviceTypeRequestEnum | "DEVICE_TYPE_UNKNOWN"
  /**
   * Тип энергоресурса
   */
  metricType?: MeasurementMetricTypeRequestEnum | "METRIC_TYPE_UNKNOWN"
  /**
   * Сдвиг таймзоны относительно UTC для даты synced_at
   */
  utcOffset?: number
  /**
   * Тип единицы измерения, в которой представлено, получаемое измерение
   */
  unitType?: MeasurementUnitTypeRequestEnum | "UNIT_TYPE_UNKNOWN"
}
/**
 * Измерение.
 * Очередь key.telemetry_consumer.measurement_stream_request.v1
 */
export type MeasurementResponseDto = {
  /**
   * Идентификатор
   */
  indicatorId: number
  /**
   * Значение
   */
  value: number
  /**
   * Временная метка сбора счётчиком.
   * Если не передано берётся серверное время
   */
  syncedAt: string | null
  /**
   * ФИАС
   */
  fiasId: string | null
  /**
   * Идентификатор устройства
   */
  deviceId: number | null
  /**
   * Идентификатор родительского устройства
   */
  deviceParentId: number | null
  /**
   * Модель устройства
   */
  deviceModel: string | null
  /**
   * Тип устройства
   */
  deviceType: MeasurementDeviceTypeResponseEnum
  /**
   * Тип энергоресурса
   */
  metricType: MeasurementMetricTypeResponseEnum
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Сдвиг таймзоны относительно UTC для даты synced_at
   */
  utcOffset: number
  /**
   * Тип единицы измерения, в которой представлено, получаемое измерение
   */
  unitType: MeasurementUnitTypeResponseEnum
}
/**
 * Фильтр измерений.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type MeasurementFilterRequestDto = {
  /**
   * По ФИАСам
   */
  fiasIds?: string[]
  /**
   * По идентификаторам
   */
  deviceIds?: number[]
  /**
   * По идентификаторам индикаторов
   */
  indicatorIds?: number[]
  /**
   * От даты синхронизации включительно (>=)
   */
  beginSyncedAt?: string | null
  /**
   * До даты синхронизации (<)
   */
  endSyncedAt?: string | null
  /**
   * По моделям устройств
   */
  deviceModels?: string[]
  /**
   * По типам устройств
   */
  deviceTypes?: MeasurementDeviceTypeResponseEnum[]
  /**
   * По типам энергоресурса
   */
  metricTypes?: MeasurementMetricTypeResponseEnum[]
  /**
   * Ограничение результатов только пограничными значениями для периода.
   * Если border_measurements_only=null возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
   * Если border_measurements_only=falsе возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
   * Если заданы border_measurements_only=true, begin_synced_at, end_synced_at возвращаем два измерения ближайшие к границам периода.
   * Если заданы border_measurements_only=true, и не задана end_synced_at возвращаем одно измерение ближайшее к begin_synced_at.
   * Если заданы border_measurements_only=true, и не задана begin_synced_at возвращаем одно измерение ближайшее к end_synced_at.
   * Если заданы border_measurements_only=true и не заданы begin_synced_at и end_synced_at возвращаем ошибку валидации параметров
   */
  isBorderMeasurementsOnly?: boolean | null
}
/**
 * Фильтр измерений.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type MeasurementFilterResponseDto = {
  /**
   * По ФИАСам
   */
  fiasIds: string[]
  /**
   * По идентификаторам
   */
  deviceIds: number[]
  /**
   * По идентификаторам индикаторов
   */
  indicatorIds: number[]
  /**
   * От даты синхронизации включительно (>=)
   */
  beginSyncedAt: string | null
  /**
   * До даты синхронизации (<)
   */
  endSyncedAt: string | null
  /**
   * По моделям устройств
   */
  deviceModels: string[]
  /**
   * По типам устройств
   */
  deviceTypes: MeasurementDeviceTypeResponseEnum[]
  /**
   * По типам энергоресурса
   */
  metricTypes: MeasurementMetricTypeResponseEnum[]
  /**
   * Ограничение результатов только пограничными значениями для периода.
   * Если border_measurements_only=null возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
   * Если border_measurements_only=falsе возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
   * Если заданы border_measurements_only=true, begin_synced_at, end_synced_at возвращаем два измерения ближайшие к границам периода.
   * Если заданы border_measurements_only=true, и не задана end_synced_at возвращаем одно измерение ближайшее к begin_synced_at.
   * Если заданы border_measurements_only=true, и не задана begin_synced_at возвращаем одно измерение ближайшее к end_synced_at.
   * Если заданы border_measurements_only=true и не заданы begin_synced_at и end_synced_at возвращаем ошибку валидации параметров
   */
  isBorderMeasurementsOnly: boolean | null
}
/**
 * Параметры пагинации измерений
 */
export type MeasurementPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: SYNCED_AT
   */
  orderByType?: MeasurementPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: MeasurementPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Параметры пагинации измерений
 */
export type MeasurementPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: SYNCED_AT
   */
  orderByType: MeasurementPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: MeasurementPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Запрос сохранения потока измерения
 */
export type PostMeasurementHalfDuplexRequestDto = {
  /**
   * Измерение
   */
  data: MeasurementRequestDto
}
/**
 * Ответ на запрос сохранения потока измерений
 */
export type PostMeasurementHalfDuplexResponseDto = {
}
/**
 * Запрос сохранения измерения
 */
export type PostMeasurementRequestDto = {
  /**
   * Измерение
   */
  data: MeasurementRequestDto
}
/**
 * Ответ на запрос сохранения измерения
 */
export type PostMeasurementResponseDto = {
}
/**
 * Данные отчёта на дату
 */
export type ReportDataRequestDto = {
  /**
   * Массив индикаторов с данными для отчёта
   */
  entries?: ReportEntryRequestDto[]
}
/**
 * Данные отчёта на дату
 */
export type ReportDataResponseDto = {
  /**
   * Массив индикаторов с данными для отчёта
   */
  entries: ReportEntryResponseDto[]
}
/**
 * Значения индикаторов для отчёта.
 * В формате [id1: [timeframe1, value1], id2: [timeframe2, value2]]
 */
export type ReportEntryRequestDto = {
  /**
   * Идентификатор индикатора
   */
  indicatorId?: number
  /**
   * Дата последнего снятия показания, ближайшего к началу дня. На дату отчёта или ранее
   */
  syncedAt?: string[]
  /**
   * Значение
   */
  value?: number[]
}
/**
 * Значения индикаторов для отчёта.
 * В формате [id1: [timeframe1, value1], id2: [timeframe2, value2]]
 */
export type ReportEntryResponseDto = {
  /**
   * Идентификатор индикатора
   */
  indicatorId: number
  /**
   * Дата последнего снятия показания, ближайшего к началу дня. На дату отчёта или ранее
   */
  syncedAt: string[]
  /**
   * Значение
   */
  value: number[]
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества преобразованных измерений
   */
  "GetMeasurementConvertedCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества преобразованных измерений",
    "fields": {
      /**
       * Параметры фильтрации измерений
       */
      "filter": {
        "type": "MeasurementFilter",
        "text": "Параметры фильтрации измерений",
      },
    },
  },
  /**
   * Ответ на запрос получения количества преобразованных измерений
   */
  "GetMeasurementConvertedCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества преобразованных измерений",
    "fields": {
      /**
       * Всего измерений
       */
      "data": {
        "type": "int32",
        "text": "Всего измерений",
      },
    },
  },
  /**
   * Запрос получения списка преобразованных измерений
   */
  "GetMeasurementConvertedListRequest": {
    "kind": "class",
    "text": "Запрос получения списка преобразованных измерений",
    "fields": {
      /**
       * Параметры фильтрации измерений
       */
      "filter": {
        "type": "MeasurementFilter",
        "text": "Параметры фильтрации измерений",
      },
      /**
       * Параметры пагинации по измерениям
       */
      "paging": {
        "type": "MeasurementPaging",
        "text": "Параметры пагинации по измерениям",
      },
    },
  },
  /**
   * Ответ на запрос получения списка преобразованных измерений
   */
  "GetMeasurementConvertedListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка преобразованных измерений",
    "fields": {
      /**
       * Значение измерения
       */
      "data": {
        "type": "Measurement",
        "text": "Значение измерения",
      },
    },
  },
  /**
   * Запрос получения количества измерений
   */
  "GetMeasurementCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества измерений",
    "fields": {
      /**
       * Параметры фильтрации измерений
       */
      "filter": {
        "type": "MeasurementFilter",
        "text": "Параметры фильтрации измерений",
      },
    },
  },
  /**
   * Ответ на запрос получения количества измерений
   */
  "GetMeasurementCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества измерений",
    "fields": {
      /**
       * Всего измерений
       */
      "data": {
        "type": "int32",
        "text": "Всего измерений",
      },
    },
  },
  /**
   * Запрос получения списка измерений
   */
  "GetMeasurementListRequest": {
    "kind": "class",
    "text": "Запрос получения списка измерений",
    "fields": {
      /**
       * Параметры фильтрации измерений
       */
      "filter": {
        "type": "MeasurementFilter",
        "text": "Параметры фильтрации измерений",
      },
      /**
       * Параметры пагинации по измерениям
       */
      "paging": {
        "type": "MeasurementPaging",
        "text": "Параметры пагинации по измерениям",
      },
    },
  },
  /**
   * Ответ на запрос получения списка измерений
   */
  "GetMeasurementListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка измерений",
    "fields": {
      /**
       * Значение измерения
       */
      "data": {
        "type": "Measurement",
        "text": "Значение измерения",
      },
    },
  },
  /**
   * Запрос отчёта по показаниям на дату.
   * Если дата не передана, отчёт на текущую дату
   */
  "GetMeasurementReportDateRequest": {
    "kind": "class",
    "text": "Запрос отчёта по показаниям на дату.\nЕсли дата не передана, отчёт на текущую дату",
    "fields": {
      /**
       * Заданная дата отчёта
       */
      "reportDateAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Заданная дата отчёта",
      },
      /**
       * Список идентификаторов индикаторов.
       * Если не указано, в отчёт добавляются все индикаторы согласно фильтрам
       */
      "indicatorIds": {
        "type": "int32",
        "text": "Список идентификаторов индикаторов.\nЕсли не указано, в отчёт добавляются все индикаторы согласно фильтрам",
      },
      /**
       * Тип энергоресурса.
       * Обязательный, отчёт по одному ресурсу
       */
      "metricType": {
        "type": "Measurement.MetricType",
        "text": "Тип энергоресурса.\nОбязательный, отчёт по одному ресурсу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ с отчётом по показаниям на дату
   */
  "GetMeasurementReportDateResponse": {
    "kind": "class",
    "text": "Ответ с отчётом по показаниям на дату",
    "fields": {
      /**
       * Уникальный идентификатор запроса. Формат GUID
       */
      "requestId": {
        "type": "string",
        "text": "Уникальный идентификатор запроса. Формат GUID",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата отчёта UTC
       */
      "reportDateAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата отчёта UTC",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Данные отчёта
       */
      "data": {
        "type": "ReportData",
        "text": "Данные отчёта",
      },
    },
  },
  /**
   * Измерение.
   * Очередь key.telemetry_consumer.measurement_stream_request.v1
   */
  "Measurement": {
    "kind": "class",
    "text": "Измерение.\nОчередь key.telemetry_consumer.measurement_stream_request.v1",
    "fields": {
      /**
       * Идентификатор
       */
      "indicatorId": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение
       */
      "value": {
        "type": "float",
        "text": "Значение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Временная метка сбора счётчиком.
       * Если не передано берётся серверное время
       */
      "syncedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Временная метка сбора счётчиком.\nЕсли не передано берётся серверное время",
      },
      /**
       * ФИАС
       */
      "fiasId": {
        "type": "google.protobuf.StringValue",
        "text": "ФИАС",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор устройства",
      },
      /**
       * Идентификатор родительского устройства
       */
      "deviceParentId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификатор родительского устройства",
      },
      /**
       * Модель устройства
       */
      "deviceModel": {
        "type": "google.protobuf.StringValue",
        "text": "Модель устройства",
      },
      /**
       * Тип устройства
       */
      "deviceType": {
        "type": "Measurement.DeviceType",
        "text": "Тип устройства",
      },
      /**
       * Тип энергоресурса
       */
      "metricType": {
        "type": "Measurement.MetricType",
        "text": "Тип энергоресурса",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Сдвиг таймзоны относительно UTC для даты synced_at
       */
      "utcOffset": {
        "type": "int32",
        "text": "Сдвиг таймзоны относительно UTC для даты synced_at",
      },
      /**
       * Тип единицы измерения, в которой представлено, получаемое измерение
       */
      "unitType": {
        "type": "Measurement.UnitType",
        "text": "Тип единицы измерения, в которой представлено, получаемое измерение",
      },
    },
  },
  /**
   * Фильтр измерений.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "MeasurementFilter": {
    "kind": "class",
    "text": "Фильтр измерений.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По ФИАСам
       */
      "fiasIds": {
        "type": "string",
        "text": "По ФИАСам",
      },
      /**
       * По идентификаторам
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам",
      },
      /**
       * По идентификаторам индикаторов
       */
      "indicatorIds": {
        "type": "int32",
        "text": "По идентификаторам индикаторов",
      },
      /**
       * От даты синхронизации включительно (>=)
       */
      "beginSyncedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты синхронизации включительно (>=)",
      },
      /**
       * До даты синхронизации (<)
       */
      "endSyncedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты синхронизации (<)",
      },
      /**
       * По моделям устройств
       */
      "deviceModels": {
        "type": "string",
        "text": "По моделям устройств",
      },
      /**
       * По типам устройств
       */
      "deviceTypes": {
        "type": "Measurement.DeviceType",
        "text": "По типам устройств",
      },
      /**
       * По типам энергоресурса
       */
      "metricTypes": {
        "type": "Measurement.MetricType",
        "text": "По типам энергоресурса",
      },
      /**
       * Ограничение результатов только пограничными значениями для периода.
       * Если border_measurements_only=null возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
       * Если border_measurements_only=falsе возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).
       * Если заданы border_measurements_only=true, begin_synced_at, end_synced_at возвращаем два измерения ближайшие к границам периода.
       * Если заданы border_measurements_only=true, и не задана end_synced_at возвращаем одно измерение ближайшее к begin_synced_at.
       * Если заданы border_measurements_only=true, и не задана begin_synced_at возвращаем одно измерение ближайшее к end_synced_at.
       * Если заданы border_measurements_only=true и не заданы begin_synced_at и end_synced_at возвращаем ошибку валидации параметров
       */
      "isBorderMeasurementsOnly": {
        "type": "google.protobuf.BoolValue",
        "text": "Ограничение результатов только пограничными значениями для периода.\nЕсли border_measurements_only=null возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).\nЕсли border_measurements_only=falsе возвращаем измерения по условиям фильтра, уникальные по (indicator_id, synced_at).\nЕсли заданы border_measurements_only=true, begin_synced_at, end_synced_at возвращаем два измерения ближайшие к границам периода.\nЕсли заданы border_measurements_only=true, и не задана end_synced_at возвращаем одно измерение ближайшее к begin_synced_at.\nЕсли заданы border_measurements_only=true, и не задана begin_synced_at возвращаем одно измерение ближайшее к end_synced_at.\nЕсли заданы border_measurements_only=true и не заданы begin_synced_at и end_synced_at возвращаем ошибку валидации параметров",
      },
    },
  },
  /**
   * Параметры пагинации измерений
   */
  "MeasurementPaging": {
    "kind": "class",
    "text": "Параметры пагинации измерений",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: SYNCED_AT
       */
      "orderByType": {
        "type": "MeasurementPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: SYNCED_AT",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "MeasurementPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Запрос сохранения потока измерения
   */
  "PostMeasurementHalfDuplexRequest": {
    "kind": "class",
    "text": "Запрос сохранения потока измерения",
    "fields": {
      /**
       * Измерение
       */
      "data": {
        "type": "Measurement",
        "text": "Измерение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения потока измерений
   */
  "PostMeasurementHalfDuplexResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения потока измерений",
  },
  /**
   * Запрос сохранения измерения
   */
  "PostMeasurementRequest": {
    "kind": "class",
    "text": "Запрос сохранения измерения",
    "fields": {
      /**
       * Измерение
       */
      "data": {
        "type": "Measurement",
        "text": "Измерение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения измерения
   */
  "PostMeasurementResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения измерения",
  },
  /**
   * Данные отчёта на дату
   */
  "ReportData": {
    "kind": "class",
    "text": "Данные отчёта на дату",
    "fields": {
      /**
       * Массив индикаторов с данными для отчёта
       */
      "entries": {
        "type": "ReportEntry",
        "text": "Массив индикаторов с данными для отчёта",
      },
    },
  },
  /**
   * Значения индикаторов для отчёта.
   * В формате [id1: [timeframe1, value1], id2: [timeframe2, value2]]
   */
  "ReportEntry": {
    "kind": "class",
    "text": "Значения индикаторов для отчёта.\nВ формате [id1: [timeframe1, value1], id2: [timeframe2, value2]]",
    "fields": {
      /**
       * Идентификатор индикатора
       */
      "indicatorId": {
        "type": "int32",
        "text": "Идентификатор индикатора",
      },
      /**
       * Дата последнего снятия показания, ближайшего к началу дня. На дату отчёта или ранее
       */
      "syncedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего снятия показания, ближайшего к началу дня. На дату отчёта или ранее",
      },
      /**
       * Значение
       */
      "value": {
        "type": "float",
        "text": "Значение",
      },
    },
  },
  /**
   * Справочник типов устройств
   */
  "Measurement.DeviceType": {
    "kind": "enum",
    "text": "Справочник типов устройств",
    "values": {
      /**
       * Значение не указано
       */
      "DEVICE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Коммуникационный модуль
       */
      "HUB": {
        "i": 1,
        "text": "Коммуникационный модуль",
      },
      /**
       * Счетчик импульсов - регистратор
       */
      "PULSE_COUNTER_RECORDER": {
        "i": 2,
        "text": "Счетчик импульсов - регистратор",
      },
      /**
       * Счетчик импульсов - регистратор LoRaWAN
       */
      "PULSE_COUNTER_RECORDER_LR": {
        "i": 3,
        "text": "Счетчик импульсов - регистратор LoRaWAN",
      },
      /**
       * Прибор учета расхода коммунальных услуг
       */
      "METERING_DEVICE": {
        "i": 4,
        "text": "Прибор учета расхода коммунальных услуг",
      },
      /**
       * Конвертер интерфейсов
       */
      "INTERFACE_CONVERTER": {
        "i": 5,
        "text": "Конвертер интерфейсов",
      },
      /**
       * M-BUS концентратор
       */
      "M_BUS_HUB": {
        "i": 6,
        "text": "M-BUS концентратор",
      },
      /**
       * Модуль связи LoRaWAN
       */
      "COMMUNICATION_MODULE_LR": {
        "i": 7,
        "text": "Модуль связи LoRaWAN",
      },
      /**
       * Базовая станция LoRaWAN
       */
      "BASE_LR": {
        "i": 8,
        "text": "Базовая станция LoRaWAN",
      },
    },
  },
  /**
   * Справочник типов энергоресурсов
   */
  "Measurement.MetricType": {
    "kind": "enum",
    "text": "Справочник типов энергоресурсов",
    "values": {
      /**
       * Значение не указано
       */
      "METRIC_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Горячая вода
       */
      "HOT_WATER": {
        "i": 1,
        "text": "Горячая вода",
      },
      /**
       * Холодная вода
       */
      "COLD_WATER": {
        "i": 2,
        "text": "Холодная вода",
      },
      /**
       * Теплоэнергия
       */
      "HEAT": {
        "i": 3,
        "text": "Теплоэнергия",
      },
      /**
       * Газ
       */
      "GAS": {
        "i": 4,
        "text": "Газ",
      },
      /**
       * Электроэнергия
       */
      "ELECTRICITY": {
        "i": 5,
        "text": "Электроэнергия",
      },
    },
  },
  /**
   * Справочник типов единиц измерений
   */
  "Measurement.UnitType": {
    "kind": "enum",
    "text": "Справочник типов единиц измерений",
    "values": {
      /**
       * Значение не указано
       */
      "UNIT_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Процент
       */
      "PERCENT": {
        "i": 1,
        "text": "Процент",
      },
      /**
       * Градус по Цельсию
       */
      "C": {
        "i": 2,
        "text": "Градус по Цельсию",
      },
      /**
       * Ватт
       */
      "WT": {
        "i": 3,
        "text": "Ватт",
      },
      /**
       * Гигакалория
       */
      "GKAL": {
        "i": 4,
        "text": "Гигакалория",
      },
      /**
       * Количество
       */
      "VALUE": {
        "i": 5,
        "text": "Количество",
      },
      /**
       * Киловaтт-час
       */
      "KWH": {
        "i": 6,
        "text": "Киловaтт-час",
      },
      /**
       * Килограмм на квадратный сантиметр
       */
      "KG_CM2": {
        "i": 7,
        "text": "Килограмм на квадратный сантиметр",
      },
      /**
       * Килограмм-сила на квадратный сантиметр
       */
      "KGF_CM2": {
        "i": 8,
        "text": "Килограмм-сила на квадратный сантиметр",
      },
      /**
       * Кубический метр
       */
      "M3": {
        "i": 9,
        "text": "Кубический метр",
      },
      /**
       * Кубический метр в час
       */
      "M3_H": {
        "i": 10,
        "text": "Кубический метр в час",
      },
      /**
       * Мегапаскаль
       */
      "MPA": {
        "i": 11,
        "text": "Мегапаскаль",
      },
      /**
       * Миллисекунда
       */
      "MS": {
        "i": 12,
        "text": "Миллисекунда",
      },
      /**
       * Флаг состояния
       */
      "BOOLEAN": {
        "i": 13,
        "text": "Флаг состояния",
      },
      /**
       * Тонна
       */
      "T": {
        "i": 14,
        "text": "Тонна",
      },
      /**
       * Тонна в час
       */
      "T_H": {
        "i": 15,
        "text": "Тонна в час",
      },
      /**
       * Час
       */
      "H": {
        "i": 16,
        "text": "Час",
      },
      /**
       * Безразмерная величина
       */
      "NON_MEASURABLE": {
        "i": 17,
        "text": "Безразмерная величина",
      },
      /**
       * Импульс
       */
      "IMP": {
        "i": 18,
        "text": "Импульс",
      },
      /**
       * Джоуль
       */
      "J": {
        "i": 19,
        "text": "Джоуль",
      },
      /**
       * Килоджоуль
       */
      "KJ": {
        "i": 20,
        "text": "Килоджоуль",
      },
      /**
       * Гигаджоуль
       */
      "GJ": {
        "i": 21,
        "text": "Гигаджоуль",
      },
      /**
       * Ватт-час
       */
      "WTH": {
        "i": 22,
        "text": "Ватт-час",
      },
      /**
       * Киловатт
       */
      "KWT": {
        "i": 23,
        "text": "Киловатт",
      },
      /**
       * Минута
       */
      "MIN": {
        "i": 24,
        "text": "Минута",
      },
      /**
       * Секунда
       */
      "S": {
        "i": 25,
        "text": "Секунда",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "MeasurementPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "MeasurementPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору индикатора
       */
      "INDICATOR_ID": {
        "i": 1,
        "text": "По идентификатору индикатора",
      },
      /**
       * По дате synced_at
       */
      "SYNCED_AT": {
        "i": 2,
        "text": "По дате synced_at",
      },
    },
  },
}